import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TChatMsg } from '../types/chat.types';

interface ChatState {
  chatData: TChatMsg[];
  chatLoading: boolean;
  replyText: string;
}

const initialState: ChatState = {
  chatData: [],
  chatLoading: false,
  replyText: '',
};

const chatSlice = createSlice({
  name: 'chat',
  initialState,
  reducers: {
    setChatData: (state, action: PayloadAction<TChatMsg[]>) => {
      state.chatData = action.payload;
    },
    setChatLoading: (state, action: PayloadAction<boolean>) => {
      state.chatLoading = action.payload;
    },
    setReplyText: (state, action: PayloadAction<string>) => {
      state.replyText = action.payload;
    },
  },
});

export const { setChatData, setChatLoading, setReplyText } = chatSlice.actions;

export default chatSlice.reducer;